import axios from "api/axios";

export const getAllTopics = async () => {
  const response = await axios.get("/api/topics/");
  return response.data;
};

export const getAllTopicsByTemplateId = async (templateId) => {
  const response = await axios.get(`/api/topics/templateId/${templateId}`);
  return response.data;
};